<template>
  <transition>
    <div v-if="visible" class="dialog-mask">
      <!--      头部功能区-->
      <div class="la_head_box">
        <!--        关闭-->
        <div class="btn_item close-btn" @click.stop="funBtnClick(funBtnEmu.close)">
          <img src="~/images/big_img_clo_icon.webp" alt="" >
        </div>
      </div>
      <!--      中间内容轮播器-->
      <div class="content_box" @click.stop="funBtnClick(funBtnEmu.close)">
        <div class="con_box">
          <img
ref="imgRef" class="--img" :style="{ objectFit: 'contain', height: '100%' }" :src="dataInfo.url" srcset="" @click.stop=""
            @load="handleLoad" @error="handleError" >
          <!-- <CardImg :object-fit="'contain'" class="image" :imgUrl="dataInfo.url"></CardImg> -->
          <!--          <img  :src="dataInfo.url" alt="" srcset="">-->
          <!-- <video class="video" v-else-if="dataInfo.type == 'video'" :src="dataInfo.url"></video> -->
        </div>
        <!--              底部操作区-->
        <div class="cont_btm">
          <slot name="footer" :data-info="dataInfo"/>
        </div>
      </div>
    </div>
  </transition>

</template>

<script setup>
const emit = defineEmits(['update:visible']);
const props = defineProps({
  // 显隐
  visible: {
    type: Boolean,
    default: false,
  },
  // 数据源
  dataInfo: {
    type: Object,
    default: () => ({}),
  },
});
const visible = computed(() => props.visible);
const dataInfo = computed(() => props.dataInfo);
// 跑马灯实数据格式示例
// const largeItem = {
//   url: '图片/视频地址',
//   type: 'image/video',
// };
// const state = reactive({ isMobile:false, // mobileAndTabletCheck(),
// });

// 功能按按钮操作----------------------------------------------
// 每个按钮的假枚举
const funBtnEmu = {
  dow: 'download',
  close: 'close',
  like: 'like',
  dislike: 'dislike',
  del: 'delete',
};
const funBtnClick = () => {
  close();
};
/**
 * 关闭轮播图弹框
 */
const close = () => {
  emit('update:visible', false);
  // props.visible = false
  // resumePageScroll();
};

// const doNotPageScroll = () => {
//   let appBox = document.getElementById("app");
//   let viewportWidth = window.innerWidth;
//   let scrollbarWidth = viewportWidth - appBox.offsetWidth;
//   document.body.style.paddingRight = scrollbarWidth + "px";
//   document.body.style.overflow = "hidden";
//   document.body.style.height = "100%";
// };

// const resumePageScroll = () => {
//   document.body.style.overflow = "";
//   document.body.style.height = "";
//   document.body.style.paddingRight = "";
// };

/**
 * 大图显示时底部页面禁止滚动
 */
// watchEffect(() => {
//   if (props.visible) {
//     doNotPageScroll();
//   } else {
//     resumePageScroll();
//   }
// });
</script>

<style scoped lang="scss">
div {
  box-sizing: border-box;
}

/* 下面我们会解释这些 class 是做什么的 */
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.dialog-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 500;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(20px);
}

.la_head_box {
  position: absolute;
  top: 40px;
  right: 60px;
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: end;
  z-index: 299;
  cursor: pointer;
}

.btn_item {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.15);
  display: flex;
  justify-content: center;
  align-items: center;
  //background-color: #6BD400;

  img {
    width: 100%;
    height: 100%;
  }
}

.content_box {
  width: 100%;
  max-width: 1400px;
  padding: 100px 50px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
}

.cont_box {
  width: 100%;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
}

.con_box {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  min-width: 50vw;
  min-height: 50vh;
  overflow: hidden;

  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;

    img {
      object-fit: contain;
    }
  }

  .video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.cont_btm {
  width: 100%;
  height: auto;
  max-height: 72px;
  overflow: hidden;
  position: relative;
  margin-top: 30px;
}

.is_strrt {
  visibility: hidden;
}

.is_end {
  visibility: hidden;
}

.close-btn {
  transition: transform 0.3s;
  &:hover {
    transform: scale(1.05);
  }
}

@media (any-hover: hover) {}

@media screen and (max-width: 767px) {
  .content_box {
    padding-left: 0;
    padding-right: 0;
  }

  .la_head_box {
    top: 20px;
    right: 20px;
  }

  .btn_item {
    width: 30px;
    height: 30px;
  }
}

@media screen and (max-width: 375px) {
  .content_box {
    padding-top: 80px;
    padding-bottom: 30px;
  }
}
</style>
